module.exports = "<div class=\"disabled-payment-instructions\">\n    <h1>\n        Payment Details\n    </h1>\n\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"\">\n                <p>Payment details will appear when Financing Documents are complete.</p>\n            </div>\n        </div>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/appDetail/paymentInstructions/disabledPaymentInstructions.html
// module id = 598
// module chunks = 1